import { z } from 'zod'

export const reportsSchema = z.object({
  page: z.coerce.number().optional(),
  size: z.coerce.number().optional(),
  sort: z
    .enum(['Name', 'Language', 'CreatedBy', 'Created', 'AllProjects', 'MimeType'])
    .optional(),
  sortDirection: z.enum(['ASC', 'DESC']).optional(),
  quickFilter: z.enum(['All', 'ByMe', 'ByOthers']).optional(),
  search: z.string().optional()
})
